<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" @vm-action="deleteCategoriesConfirm(newRecord)" :vm-action="true" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="true" :vm-is-valid="!$v.newRecord.$invalid" :vm-active="isModalVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("categories.title_placeholder")' :danger="$v.newRecord.title.$invalid && $v.newRecord.title.$model" danger-text="Requerido" v-model="newRecord.title" :label='$t("categories.title")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("categories.total_price")' v-model="newRecord.total_price" :label='$t("categories.total_price")')
          //- vm-input(v-model='newRecord.total_price' v-money='money')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("categories.discount")' v-model="newRecord.discount" :label='$t("categories.discount")')
          //- vm-input(v-model='newRecord.discount' v-money='money')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("categories.about_placeholder")' v-model="newRecord.about" :label='$t("categories.about")')
          //- vm-input(v-model='price' v-money='money')

      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          .form__label
          label.label(style='padding-left: 5px; font-size: .85rem; color: rgba(0,0,0,.7);') Color
          .form__input
            v-swatches(popover-x='left' :danger="$v.newRecord.color.$invalid && $v.newRecord.color.$model" danger-text="Requerido" v-model="newRecord.color" :label='$t("categories.color")')

          //- vm-select(:placeholder='$t("categories.color_placeholder")' :danger="$v.newRecord.color.$invalid && $v.newRecord.color.$model" danger-text="Requerido" v-model="newRecord.color" :label='$t("categories.color")')
          //-   vm-select-item(value="#3498db" text="Azul")
          //-   vm-select-item(value="#2ecc71" text="Verde")
          //-   vm-select-item(value="#f1c40f" text="Amarillo")
          //-   vm-select-item(value="#e74c3c" text="Rojo")
          //-   vm-select-item(value="#e67e22" text="Naranja")
          //-   vm-select-item(value="#9b59b6" text="Morado")
          //-   vm-select-item(value="#95a5a6" text="Gris")
</template>

<script>
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
import VSwatches from 'vue-swatches'
import { Money } from 'v-money'

import 'vue-swatches/dist/vue-swatches.css'
const { mapGetters, mapActions } = createNamespacedHelpers('Categories')

export default {
  name: 'ModalCategories',
  components: {
    VSwatches,
    Money },
  data () {
    return {
      colorPicker: null,
      color: '#A463BF',
      price: 0,
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '$ ',
        suffix: ' ',
        precision: 2,
        masked: true
      }
    }
  },
  created () {

  },
  props: {
    newRecord: {
      type: Object
    },
    isAdd: {
      default: true,
      type: Boolean
    }
  },
  validations: {
    newRecord: {
      title: {
        required
      },
      color: {
        required
      }
    }
  },
  computed: {
    ...mapGetters([
      'isModalVisible',
      'categoriesCatalog'
    ]),
    getTitle () {
      return this.isAdd ? this.$t('categories.add') : this.$t('categories.edit')
    }
  },
  methods: {
    ...mapActions([
      'addCategories',
      'editCategories',
      'deleteCategories',
      'setModalVisible',
      'loadCatalog'
    ]),
    formatToSlug (str) {
      str = str.replace(/^\s+|\s+$/g, '') // trim
      str = str.toLowerCase()

      // remove accents, swap ñ for n, etc
      let from = 'ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;'
      let to = 'aaaaaeeeeeiiiiooooouuuunc------'
      for (let i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
      }
      str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-') // collapse dashes
      return str
    },
    saveRecord () {
      this.isAdd ? this.addCategories(this.newRecord) : this.editCategories(this.newRecord)
    },
    async deleteCategoriesConfirm (categories) {
      let t = this
      this.auxDeleteCategories = () => {
        t.deleteCategories(categories)
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { attribute: this.$t(categories.layer_id) }),
        accept: this.auxDeleteCategories
      })
    },
    autoCompleteFunc (value, url) {
      this.loadCatalog({ filter: value, url: url })
    },
    close () {
      this.setModalVisible(false)
    }
  },
  watch: {
    'newRecord.title' (title) {
      this.newRecord.layer_id = this.formatToSlug(title)
    }
  }
}
</script>

<style lang="scss" scoped>
  .form__label {
    padding-left: 5px;
    font-size: .85rem;
    color: rgba(0,0,0,.7);
  }
</style>
